import { useCallback, useEffect, useState } from 'react';

export const useServiceWorkerUpdate = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return undefined;

    const handleControllerChange = () => {
      if (refreshing) return;
      setRefreshing(true);
      window.location.reload();
    };

    const inspectRegistration = (registration) => {
      if (registration?.waiting) setWaitingWorker(registration.waiting);
      registration?.addEventListener?.('updatefound', () => {
        const installing = registration.installing;
        installing?.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            setWaitingWorker(installing);
          }
        });
      });
    };

    navigator.serviceWorker.ready.then(inspectRegistration).catch(() => {});
    navigator.serviceWorker.getRegistration?.().then(inspectRegistration).catch(() => {});
    navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
    };
  }, [refreshing]);

  const applyUpdate = useCallback(() => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
  }, [waitingWorker]);

  return {
    updateAvailable: Boolean(waitingWorker),
    applyUpdate,
  };
};

export default useServiceWorkerUpdate;
